// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"151":"ea0844ae8aab586a","552":"b34cf9a40701d5ff","602":"5d7b51f6dd74fc12","982":"8ef09666283353e6"}[chunkId] + ".js";
};